import { render, staticRenderFns } from "./AddMaterialList.vue?vue&type=template&id=0e8afc61"
import script from "./AddMaterialList.vue?vue&type=script&lang=js"
export * from "./AddMaterialList.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialList.vue?vue&type=style&index=0&id=0e8afc61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports